import { GetRowIdParams } from 'ag-grid-community';

export const getRowId = (params: GetRowIdParams) => {
  return params?.data?.attachmentId ?? String(params?.data?.rowId ?? '');
};
